exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-service-page .card-filters h3{margin-bottom:10px}.detail-service-page .card-filters .content-filters{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.detail-service-page .card-filters .content-filters .field{margin:0}.detail-service-page .card-filters .content-filters .field .field{width:80%}.detail-service-page .card-filters .content-filters .field .b-radio.radio.button{margin:0}.detail-service-page .card-filters .content-filters .field .input{min-width:250px}", ""]);

// exports
